import axios from 'axios';
import router from '../router';

const url = process.env.VUE_APP_API_URL; // Usa a URL da variável de ambiente

export const http = axios.create({
  baseURL: url,
});

http.defaults.timeout = 90000000;

// Interceptor de requisição: injeta o Bearer token automaticamente se disponível
http.interceptors.request.use(
  function (config) {
    try {
      const user = JSON.parse(sessionStorage.getItem('user'));
      if (user && user.accessToken) {
        if (!config.headers.Authorization && !config.headers.authorization) {
          config.headers.Authorization = 'Bearer ' + user.accessToken;
        }
      }
    } catch (e) {
      // Ignora erro de parse caso sessionStorage esteja inválido
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Interceptor de resposta: trata 401 redirecionando para login
http.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      const currentHash = window.location.hash || '';
      if (!currentHash.includes('/login')) {
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('selectedModule');
        if (router.currentRoute && router.currentRoute.path !== '/login') {
          router.push('/login').catch(() => {});
        }
      }
    }
    return Promise.reject(error);
  }
);

export default {
  url,
};

//const url = 'http://10.10.1.5:8091/'
//npm install dotenv@8.6.0

//const url = 'https://maestrix.grupoparque.com.br:8443/api-dashboard/'
//const url_dash = 'https://api.gpdf.com.br/apisocio/api/'
